import React, {useEffect} from 'react';
import CardsComponent from '../common/cards';
import {useQuery} from 'react-query';
import {GetCacheKey} from "../../services/common/utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Pagination } from "swiper";
import NojoomBannerShimmer from '../../ShimmerEffect/NojoomBannerShimmer';

function NojoomBanner({pmsitem}) {
    const {data: {data}={}, isLoading, isFetching} = useQuery([GetCacheKey("NojoomTopBanner"), pmsitem?.method, JSON.parse(pmsitem?.sourceid), {} ])

    if(isLoading || isFetching ){
      return  <NojoomBannerShimmer/>
    }
  return (
    <div className="pb-4">
        <Swiper
            className="swiper-container dls13_promo_swiper1 dls14_promo_pagination"
            spaceBetween={12}
            slidesPerView={1}
            pagination={{
                clickable: true
            }}
            modules={[Grid, Pagination]}
        >
        {data?.response?.map(item => item?.banners)[0]?.map((item) => {
            return (
            <SwiperSlide >
                <CardsComponent type={35} data={item}/>
            </SwiperSlide>
            );
        })}
        </Swiper> 
    </div>
  )
}

export default NojoomBanner
